import {combineReducers} from 'redux';
import authReducer from './authReducer';
import appReducer from "./appReducer";
import loadingReducer from "./loadingReducer";

import storage from 'redux-persist/lib/storage';
import {persistReducer} from 'redux-persist';

const persistConfig = {
	key: 'root',
	storage,
	// Sadece küçük, tekrar kullanılabilir listeleri persist et.
	// districtBounds (~22 MB GeoJSON) ASLA persist edilmemeli — localStorage kotasını patlatır
	// ve her açılışta senkron rehydrate ana thread'i bloke eder.
	whitelist: ['cities', 'eventTypes'],
};
// Auth state'ini persist etmeyelim - güvenlik nedeniyle
// const persistAuthReducer = persistReducer(persistConfig, authReducer);
const persistAppReducer = persistReducer(persistConfig, appReducer);


const rootReducer = combineReducers({
	auth: authReducer, // Auth state artık persist olmayacak
	app: persistAppReducer,
	loading: loadingReducer
})

export default rootReducer;
